import NewsletterForm from "@/components/feature/NewsletterForm";
import { site } from "@/mocks/content";

export default function SubscribeBand() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-12 md:px-6 md:pb-16">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-700 via-primary-800 to-foreground-900 px-6 py-10 text-center md:px-12 md:py-14">
        <div className="pointer-events-none absolute -left-10 -top-10 h-48 w-48 rounded-full bg-accent-500/25 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-16 -right-8 h-52 w-52 rounded-full bg-accent-400/20 blur-3xl" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur">
            <i className="ri-flashlight-fill text-accent-300" />
            {site.name} · {site.slogan}
          </span>
          <h2 className="mx-auto mt-5 max-w-2xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
            第一手内幕，先到你的收件箱
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            每天推送最独家的爆料与深度栏目，不错过任何一颗正在发酵的瓜。
          </p>
          <div className="mt-7">
            <NewsletterForm />
          </div>
        </div>
      </div>
    </section>
  );
}